import { observable } from "@legendapp/state";

const defaultValues = {
  darkMode: window.matchMedia("(prefers-color-scheme: dark)").matches,
};

export const ThemeStore$ = observable(defaultValues);

export const toggleTheme = () => ThemeStore$.darkMode.set((value) => !value);
